import React, { FC } from 'react'

import { useIntl } from 'react-intl'

import { lgbtMessages } from 'common/constants'
import { GenderItem } from 'components/page/Landing/constants'
import { SelectedFilter } from 'components/page/Landing/LandingView/LandingFilter/LandingSelectedFilter'
import { mergeAllUrls } from 'functions/mergeAllUrls'

export const CreateFilterValue: FC<{
  cleanPathname: string
  currentGender: GenderItem
  pathname: string
}> = ({ cleanPathname, currentGender, pathname }) => {
  const intl = useIntl()
  return (
    <SelectedFilter
      id={currentGender.id}
      href={mergeAllUrls(cleanPathname, currentGender.path)}
      data-name={`geo-landing-gender-select-${currentGender.id.toLowerCase()}-action`}
      isSelected={pathname.includes(currentGender.path)}
    >
      {intl.formatMessage(lgbtMessages[currentGender.name])}
    </SelectedFilter>
  )
}
